// Erken kapanış eşiği — backend Close kuralının FE karşılığı
// (ObOnboardingDataAccess.Close: UtcNow.Date < ExpectedDay90.Date → gerekçe 400).
// GÜN bazında karşılaştırılır: beklenen 90. günün kendisinde kapatmak erken
// sayılmaz. Tarih yok/bozuksa alan gösterilmez — backend zaten otoriter.
export function isEarlyClose(expectedDay90, now = new Date()) {
  if (!expectedDay90) return false;
  const expected = new Date(expectedDay90);
  if (Number.isNaN(expected.getTime())) return false;
  const day = (d) => Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return day(now) < day(expected);
}
